import * as z from 'zod';

import { validateDuplicateCPFs } from '../../../../utils/validateUniqueCpf';
import { AssociadoSchema } from './AssociadoSchema';
import { newDependentsSchema } from './newdependentsSchema';

export const schema = z
  .object({
    Associado: AssociadoSchema,
    dependents: z.optional(z.array(newDependentsSchema)),
  })
  .superRefine((data, ctx) => {
    const entries: { cpf?: string; path: (string | number)[] }[] = [];

    const user = data.Associado;
    const dependents = data.dependents || [];

    if (user.cpf) {
      entries.push({
        cpf: user.cpf,
        path: ['user', 'documents', 'cpf'],
      });
    }

    (dependents || []).forEach((dep, i) => {
      entries.push({
        cpf: dep.cpf,
        path: ['user', 'dependents', i, 'cpf'],
      });
    });

    validateDuplicateCPFs(entries, ctx);
  });

export type Schema = z.infer<typeof schema>;
